/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceItemResource { 
    id: number;
    date: string;
    title: string;
    amount: number;
    isPositive: boolean;
}

